import { render } from 'preact';
import { LocationProvider, Router, Route } from 'preact-iso';
import { Tooltip } from 'react-tooltip';

import { Header } from './components/Header.jsx';
import { Home } from './pages/Home/index.jsx';
import { NotFound } from './pages/_404.jsx';
import './style.css';
import './state/store.ts';
import './state/github.ts';

export function App() {
	return (
		<LocationProvider>
			<Header />
			<Tooltip id="commit-tooltip" place="bottom"
				clickable openOnClick
				closeEvents={{blur: true, click: true,}}
				globalCloseEvents={{escape: true, clickOutsideAnchor: true,}}/>
			<Tooltip id="job-tooltip" place="top" />
			<main>
				<Router>
					<Route path="/" component={Home} />
					<Route default component={NotFound} />
				</Router>
			</main>
		</LocationProvider>
	);
}

render(<App />, document.getElementById('app'));
